import classNames from 'classnames';
import React, { Component, PropsWithChildren, Fragment, KeyboardEvent, RefObject } from 'react';
import { Avatar } from '../index';
import { IWizardSidebarProps, IWizardSidebarStepProps } from './types';

export class WizardSidebar extends Component<PropsWithChildren<IWizardSidebarProps>> {
  public container: RefObject<HTMLDivElement>;

  constructor(props: IWizardSidebarProps) {
    super(props);
    this.container = React.createRef();
  }

  public defaultStepRenderer(props: IWizardSidebarStepProps) {
    const { index, label } = props;
    return (
      <Fragment>
        <span>
          <Avatar size={'small'}>{index + 1}</Avatar>
        </span>
        <span>{label}</span>
      </Fragment>
    );
  }

  public render() {
    const { steps, onSelect = (index: number) => null, sidebarRenderer = this.defaultStepRenderer } = this.props;
    return (
      <div className="hlc-wizard-sidebar-container" ref={this.container}>
        <div className={'hlc-wizard-sidebar'} role="tablist">
          {steps.map((step, index) => {
            const { isActive, isComplete } = step;

            const previousStep = steps[index - 1];

            const disabled = !isActive && !isComplete && !previousStep.isComplete && !previousStep.isActive; // <- Allow the next step to be clicked

            const classes = classNames('hlc-progress-step', {
              active: isActive,
              complete: isComplete,
              disabled,
            });
            return (
              <a
                className={classes}
                key={index}
                onClick={() => onSelect(index)}
                onKeyUp={(event: KeyboardEvent) => {
                  // Check for enter / space
                  if ([13, 32].includes(event.which)) {
                    onSelect(index);
                  }
                }}
                role="tab"
                tabIndex={!disabled ? 0 : -1}
              >
                {sidebarRenderer(step)}
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}
